import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { HttpService } from '../http/http.service';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})

export class LablocationService {

    public Lablocationdata: any;

    constructor(private httpService: HttpService) { }

    getLablocationByclientId(id: any) {
        const url = `${environment.LablocationApiendpoint}/lablocationListByClient/${id}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    getallLablocation() {
        const url = `${environment.LablocationApiendpoint}/get-lablocation/`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    addLablocation(data: any): Observable<any> {
        const url = `${environment.LablocationApiendpoint }/add_lab_location`
        return this.httpService.post(url, data, this.httpService.headers)
    }


    deleteLablocation(id: any) {
        const url = `${environment.LablocationApiendpoint}/delete_lab_location/${id}`;
        return this.httpService.delete(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    obtainLablocation(user: any) {
        const url = `${environment.LablocationApiendpoint}/view_lab_location/${user}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    editLablocation(data: any, Lablocation: any): Observable<any> {
        const url = `${environment.LablocationApiendpoint}/update_lab_location/${Lablocation}`
        return this.httpService.put(url, data, this.httpService.headers)
    }

    updateStatus(id: any, status: any): Observable<any> {



        let data ;
        if (status == 'Active') {
            data = {
                status: 'Inactive'
            };
        }else{
            data = {
                status: 'Active'
            };
        }
        const url = `${environment.LablocationApiendpoint}/Lablocation-change-status/${id}`;
        return this.httpService.patch(url, data, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }
    obtainLablocations(search: any) {
        const url = `${environment.LocaionApiendpoint}/location/listLablocation?${search}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    obtainFacilities(search: any) {
        const url = `${environment.LocaionApiendpoint}/location/listFacilities?${search}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    getAllCityById(id: any) {
        const url = `${environment.LablocationApiendpoint}/cities-by-state-id/${id}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    getAllCity() {
        const url = `${environment.LablocationApiendpoint}/cities?d=all`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    getAllAreacodeById(id: any) {
        const url = `${environment.LablocationApiendpoint}/area-codes-by-city-id/${id}`;
        return this.httpService.get(url, this.httpService.headers)
            .pipe(
                catchError(this.Errorhandling)
            );
    }

    // createLablocation(data: any): Observable<any> {
    //   const url = `${environment.LablocationApiEndpoint}/Lablocations`;
    //   return this.httpService.post(url, data, this.httpService.headers);
    // }

    getLablocation(data: any): Observable<any> {
        this.Lablocationdata = [
            {
                id: '1',
                emp_code: '123',
                first_name: 'Abhishek',
                last_name: 'Anand',
                email: 'temp@email.com',
                phone: '25012021',
                status: 'Active',
                city: 'Dehradun',
                state: 'Uttarakhand',
            },
        ];

        return this.Lablocationdata;
    }
    Errorhandling(err: HttpErrorResponse) {
        if (err.error instanceof ErrorEvent) {
            console.error(err.error.message);
        } else {
            console.error(`Backend returned code ${err.status}`);
        }
        return throwError('Please try again later.');
    }
}
